import { cn } from "@/lib/utils";
import { useAppI18n } from "@/hooks/useAppI18n";

export type ActiveTab = "Ongoing" | "Upcoming" | "Expired";

interface TabBarProps {
  activeTab: ActiveTab;
  counts: Record<ActiveTab, number>;
  onChange: (tab: ActiveTab) => void;
}

export function TabBar({ activeTab, counts, onChange }: TabBarProps) {
  const { t } = useAppI18n();
  const TABS: ActiveTab[] = ["Ongoing", "Upcoming", "Expired"];

  return (
    <div className="flex border-b border-border">
      {TABS.map((tab) => (
        <button
          key={tab}
          type="button"
          onClick={() => onChange(tab)}
          className={cn(
            "flex-1 py-2.5 text-sm font-rubik font-medium relative transition-colors",
            activeTab === tab
              ? "text-sunbird-theme-accent"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {t(`batchTabs.${tab.toLowerCase()}`)}
          {counts[tab] > 0 && (
            <span
              className={cn(
                "ml-1.5 inline-flex items-center justify-center rounded-full text-xs w-4 h-4 font-rubik",
                activeTab === tab
                  ? "bg-sunbird-theme-accent text-white"
                  : "bg-gray-100 text-gray-500"
              )}
            >
              {counts[tab]}
            </span>
          )}
          {/* active indicator */}
          {activeTab === tab && (
            <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-sunbird-theme-accent rounded-t-full" />
          )}
        </button>
      ))}
    </div>
  );
}
